import { USER_TYPES } from '../types/user';
import { isTravelAgent, isUserEurostarAgent, isUserStationAgent } from './user';
import { getBookingType } from './booking';
import { TICKET_PASSPORT_REQUIREMENTS } from '../types/ticket';

export const getUserType = (user) => {
  if (isUserStationAgent(user)) {
    return USER_TYPES.STATION_USER;
  }

  if (isUserEurostarAgent(user)) {
    return USER_TYPES.ANY_OTHER_ES_USER;
  }

  if (isTravelAgent(user)) {
    return USER_TYPES.TRAVEL_AGENT;
  }
};

export const getIsPassportRequired = (user, booking, ticket) => {
  const userType = getUserType(user);

  const bookingType = getBookingType(booking);

  let isPassportRequired = false;

  for (let [key, value] of TICKET_PASSPORT_REQUIREMENTS.entries()) {
    if (key.user === userType && key.booking === bookingType && key.ticket === ticket) {
      isPassportRequired = value;
      break;
    }
  }

  return isPassportRequired;
};

export const isNewPriceLessExpensive = (leg) => {
  let isLessExpensive = false;

  leg.activeBookingItems.forEach((p) => {
    let originalPrice = 0;
    let hasOriginalPrice = false;

    p.additionalDetails.forEach((ad) => {
      if (ad.key === 'original_price') {
        originalPrice = parseFloat(ad.value);
        hasOriginalPrice = true;
      }
    });

    if (hasOriginalPrice && p.price > originalPrice) {
      isLessExpensive = true;
    }
  });

  return isLessExpensive;
};
